import { CalendarEvents } from "@busy-human/k9-library";
import { DataInstance } from "@busy-human/gearbox";
import { onSnapshot, Unsubscribe, } from "firebase/firestore";
import { uniqBy } from "lodash";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { useAuth } from './auth';

export const useCalendarEvents = defineStore("calendarEvents", () => {
    const calendarEvents = ref<DataInstance<CalendarEvents.Model>[]>([]);
    const listenerCleanup = ref<Unsubscribe | null>(null);

    async function setup() {
        // Preemptive cleanup
        if(listenerCleanup.value) listenerCleanup.value();

        const calendarEventsRef = CalendarEvents.Collection.all();

            calendarEvents.value = (await calendarEventsRef.fetch()).map(doc => doc.data());

        const calendarEventCleanup = onSnapshot(calendarEventsRef.ref(), snap => {
            const data: DataInstance<CalendarEvents.Model>[] =
                snap.docs.map(docSnap =>
                    ({... docSnap.data() as CalendarEvents.Model,
                    $id: docSnap.id
                }));
            calendarEvents.value = data;
        });
        listenerCleanup.value = () => { calendarEventCleanup(); };
    }

    function cleanup() {
        if(listenerCleanup.value) listenerCleanup.value();

        calendarEvents.value = [];
    }

    const auth = useAuth();

    setup(); //Todo: Delete this later
    watch(() => auth.user, async user => {
        if(user) await setup();
        else cleanup();
    }, { immediate: true });

    const list = computed(() =>
        uniqBy([...calendarEvents.value],
            (i => i.$id))
        .sort((a, b) => a.$id.localeCompare(b.$id)));

    async function createCalendarEvent(event: CalendarEvents.Model) {
        const newEvent = await CalendarEvents.Collection.add(event);

        return newEvent.$id;
    }

    async function updateCalendarEvent(event: DataInstance<CalendarEvents.Model>){
        const tmp: CalendarEvents.Model = {...event};
        const id = event.$id;
        delete (tmp as any).$id;
        await CalendarEvents.Collection.updateDoc(id, tmp);
    }

    async function deleteCalendarEvent(id: string){
        try{
            await CalendarEvents.Collection.deleteDoc(id);
        }catch (e) {
            console.error(e);
        }
    }

    return { list, createCalendarEvent, updateCalendarEvent, deleteCalendarEvent };
});